'use client';

import { Player, TournamentPlayersResultAllOfResults } from '@spikemark/rest-api';
import { MascotWithName } from '@spikemark/ui/components/mascot-with-name';
import classNames from 'classnames';
import { ChevronRight } from 'lucide-react';
import { FC, useState } from 'react';
import { TeamPlayersDialog } from './team-players-dialog';
type ParticipantsVariant = 'small' | 'default';
type ParticipantsProps = {
  tournamentId: string;
  schools?: SchoolWithPlayers[] | null;
  variant?: ParticipantsVariant;
  rankingsEnabled?: boolean;
};
export type SchoolWithPlayers = TournamentPlayersResultAllOfResults & {
  players: (Player & {
    teamLabel?: string;
    playerSeed?: number;
    isSubstitute?: boolean;
  })[];
};
const CardContent = ({
  variant,
  school,
  playerCount
}: {
  variant: ParticipantsVariant;
  school: SchoolWithPlayers;
  playerCount: number;
}) => {
  let content = <></>;
  let additionalContent = <></>;
  const defaultVariant = variant === 'default';
  if (variant === 'small') {
    content = <p className="font-bold">{school?.teamName}</p>;
  } else {
    content = <>
        <span className="font-bold">{school?.teamName}</span>
        {playerCount ? <p>{playerCount} players</p> : <p className="text-gray-400">No players to show yet.</p>}
      </>;
    additionalContent = !!playerCount ? <ChevronRight className="ml-4 text-secondary" /> : <></>;
  }
  const mascotClassnames = classNames('flex-1', {
    'text-xs': variant === 'small'
  });
  return <>
      <MascotWithName variant={variant === 'small' ? 'xSmall' : 'medium'} alt={school.teamName ?? ''} containerClassName={mascotClassnames} path={school?.schoolLogo} data-sentry-element="MascotWithName" data-sentry-source-file="participants.tsx">
        {content}
      </MascotWithName>
      {additionalContent}
    </>;
};
export const Participants: FC<ParticipantsProps> = ({
  tournamentId,
  schools,
  variant = 'default',
  rankingsEnabled
}) => {
  const [selectedSchool, setSelectedSchool] = useState<SchoolWithPlayers>();
  const [openRosterView, setOpenRosterView] = useState(false);
  const wrapperClassnames = classNames('grid p-4 gap-4', {
    'grid-cols-2': variant === 'small',
    'grid-cols-1 md:grid-cols-2 lg:grid-cols-3': variant === 'default'
  });
  return <div className={wrapperClassnames} data-sentry-component="Participants" data-sentry-source-file="participants.tsx">
      {schools?.map(school => {
      const playersCount = school.players?.length ?? 0;
      return <div key={school.schoolId} onClick={() => {
        if (playersCount <= 0) {
          return;
        }
        setSelectedSchool(school);
        setOpenRosterView(true);
      }} className={classNames('border border-gray-200 rounded-sm p-3 flex justify-between items-center bg-gray-100 flex-1', playersCount ? 'cursor-pointer' : '')}>
            <CardContent variant={variant} school={school} playerCount={playersCount} />
          </div>;
    })}

      <TeamPlayersDialog open={openRosterView} school={selectedSchool} onClose={() => {
      setSelectedSchool(undefined);
      setOpenRosterView(false);
    }} rankingsEnabled={rankingsEnabled} data-sentry-element="TeamPlayersDialog" data-sentry-source-file="participants.tsx" />
    </div>;
};